import { useReduxState } from 'hooks';
import { User, UserCoursesProgress } from 'components/common';
import { Box, BoxBackLink } from 'components/common/box';

import type { ProgressData, UserWithBasicData } from 'shared-types';

interface Props {
  loading: boolean;
  targetUser: UserWithBasicData & { progressData: ProgressData };
}

const GroupFollowUserSummary = ({ loading, targetUser }: Props) => {
  const {
    messages,
    pageState: { group }
  } = useReduxState();

  return (
    <div className="summary">
      <Box
        loading={loading}
        title={
          <BoxBackLink
            as={`/groups/${group.id}/follow`}
            href="/groups/[groupId]/follow"
            text={messages.usersAllUsers}
          />
        }
      >
        {targetUser ? (
          <div className="row-sm row-center">
            <div className="col">
              <User enableProfileLink={true} user={targetUser} />
            </div>

            <div className="col-min">
              <UserCoursesProgress progressData={targetUser.progressData} />
            </div>
          </div>
        ) : null}
      </Box>
    </div>
  );
};

export default GroupFollowUserSummary;
